import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button, Input, Label, Spinner, Switch, Text, XStack, YStack } from 'tamagui';
import { useCreateMailAccount } from '../mail/hooks';

export function MailNewAccountRoute() {
  const navigate = useNavigate();
  const { mutate: createAccount, isPending, error } = useCreateMailAccount();

  const [label, setLabel] = useState('');
  const [host, setHost] = useState('');
  const [port, setPort] = useState('993');
  const [tls, setTls] = useState(true);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const canSubmit = label.trim() && host.trim() && username.trim() && password.trim() && !isPending;

  const submit = () => {
    createAccount(
      { label: label.trim(), host: host.trim(), port: Number(port), tls, username: username.trim(), password },
      { onSuccess: () => navigate({ to: '/mail' }) },
    );
  };

  const errorMessage = error instanceof Error ? error.message : error ? String(error) : null;

  return (
    <YStack padding="$4" gap="$4" maxWidth={480}>
      <Text fontSize="$6" fontWeight="700">Konto hinzufügen</Text>

      <YStack gap="$1">
        <Label>Bezeichnung</Label>
        <Input value={label} onChangeText={setLabel} placeholder="z.B. Arbeit" />
      </YStack>

      <YStack gap="$1">
        <Label>IMAP-Host</Label>
        <Input value={host} onChangeText={setHost} placeholder="imap.example.com" />
      </YStack>

      <XStack gap="$3">
        <YStack flex={1} gap="$1">
          <Label>Port</Label>
          <Input value={port} onChangeText={setPort} />
        </YStack>
        <YStack gap="$1" alignItems="center" justifyContent="flex-end" paddingBottom="$2">
          <Label>TLS</Label>
          <Switch checked={tls} onCheckedChange={setTls} size="$3">
            <Switch.Thumb animation="quicker" />
          </Switch>
        </YStack>
      </XStack>

      <YStack gap="$1">
        <Label>Benutzername</Label>
        <Input value={username} onChangeText={setUsername} placeholder="name@example.com" />
      </YStack>

      <YStack gap="$1">
        <Label>Passwort / App-Passwort</Label>
        <Input value={password} onChangeText={setPassword} secureTextEntry />
      </YStack>

      {errorMessage ? (
        <Text color="$red10">{errorMessage}</Text>
      ) : null}

      <XStack gap="$3">
        <Button variant="outlined" onPress={() => navigate({ to: '/mail' })}>Abbrechen</Button>
        <Button flex={1} onPress={submit} disabled={!canSubmit}>
          {isPending ? <Spinner /> : 'Verbinden & speichern'}
        </Button>
      </XStack>
    </YStack>
  );
}
